module.exports = __webpack_public_path__ + "img/gartek-portfolio-residential.6f68d73d.jpeg";